import { FeedbackManager } from '@mojility/coach-core'

const NewQuestionCreator = function ($scope, $element, questionnaireInteractor, eventsService) {
  const $ctrl = this;

  $ctrl.$onInit = function () {
    $ctrl.questionTypes = [
      {label: 'Select one answer', type: 'radio'},
      {label: 'Select one or more answers', type: 'checkbox'},
      {label: 'Text response', type: 'text'},
      {label: 'Slider question', type: 'range'}
    ];

    $ctrl.feedbackManager = new FeedbackManager($element[0], {
      ready: '+ Create new question',
      busy: 'Processing',
      fail: 'Failed'
    })
  };

  $ctrl.createQuestion = function () {
    $ctrl.feedbackManager.start();

    let questionData = {
      content: $ctrl.questionText,
      type: $ctrl.questionType
    };

    questionnaireInteractor.createNewQuestion(
      $ctrl.questionnaireId,
      questionData,
      () => {
        $ctrl.onQuestionCreation();
        $ctrl.questionText = null;
        $ctrl.questionType = null;
        $ctrl.feedbackManager.finish();
        eventsService.publishSystemMessage('New question created successfully.');
        $scope.$digest();
      },
      () => {
        $ctrl.feedbackManager.fail();
        eventsService.publishSystemError('Failed to create a new question.');
        $scope.$digest();
      });
  };


};

export default {
  name: 'newQuestionCreator',
  obj: {
    controller: NewQuestionCreator,
    templateUrl: 'components/new_question_creator.html',
    bindings: {
      questionnaireId: '<',
      onQuestionCreation: '&'
    }
  },
  deps: []
};